// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"f0962bd6","845":"9dfa2bd2"}[chunkId] + ".chunk.js";
};